import styled, { css } from "styled-components";
import { Button } from "../../spocketUI";

const HeaderContainer = styled.div`
  ${({ sticky }) => css`
    max-width: calc(100% + 66px) !important;
    height: auto;
    width: ${sticky ? "calc(100% - 200px)" : "calc(100% + 66px)"};
    margin: ${sticky
      ? "0 -54px 16px -33px !important"
      : "0 -54px 16px -33px  !important"};
    background-color: white;
    box-shadow: ${sticky
      ? "rgba(0, 0, 0, 0.1) 0px 8px 8px -8px"
      : "0 1px 0 0 #e6e8f0"};
    position: ${sticky ? "fixed" : "unset"};
    z-index: 200;
    top: 0;
    display: flex;
    align-items: center;
    justify-content: center;
    flex-direction: column;
    opacity: 1;
    padding: ${sticky ? "24px 32px;" : "24px 32px"};
    padding-bottom: 8px;

    @media (min-width: 1401px) {
      margin: ${sticky
        ? "0 -54px 16px -33px !important;"
        : "0 -54px 16px -33px;"};
    }

    @media (max-width: 768px) {
      width: ${sticky ? "100%" : "calc(100% + 30px)"};
      margin: ${sticky
        ? "60px -51px 0px -15px !important"
        : "-16px 0px 32px -15px !important"};
      opacity: ${sticky ? "0 !important" : "1"};
      visibility: ${sticky ? "hidden !important" : "visible"};
      padding: 24px 16px;
    }
  `};
`;

const HeaderContent = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  width: 100%;

  @media (max-width: 425px) {
    flex-direction: column;
  }
`;

const SearchForm = styled.form`
  width: 100%;
  position: relative;
  display: flex;
  align-items: center;

  /* Overriding Input component */
  input {
    padding: 16px;
    padding-right: 150px;
  }

  /* Overriding Button component */
  button {
    display: flex;
    align-items: center;
    position: absolute;
    right: 12px;

    img {
      margin-right: 4px;
    }
  }

  @media (max-width: 425px) {
    display: flex;

    button {
      margin-left: 0px;
      right: 0;
      padding: 8px;
      border-top-left-radius: unset;
      border-bottom-left-radius: unset;
    }

    input {
      padding: 8px;
      padding-right: 120px;
      border-top-right-radius: unset;
      border-bottom-right-radius: unset;
    }
  }
`;

const AdvancedFiltersButton = styled(Button)`
  color: #000000;
  border: solid 1px #e6e8f0;
  background-color: #ffffff;
  padding: 16px 24px;
  font-size: 14px;
  margin-left: 24px;
  display: flex;
  align-items: center;

  img {
    margin-right: 4px;
  }

  :hover {
    background-color: #f4f5f8;
  }

  @media (max-width: 425px) {
    margin: 8px 0px;
    width: 100%;
    justify-content: center;
  }
`;

const Space = styled.div`
  margin-bottom: 18px;

  @media (max-width: 768px) {
    margin-bottom: 0px;
  }
`;

export {
  HeaderContainer,
  HeaderContent,
  SearchForm,
  AdvancedFiltersButton,
  Space
};



// WEBPACK FOOTER //
// ./src/newDropshipperApp/pages/search/HeaderStyle.js